import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { AdsCoupon, CreateAdsCouponModel, EditAdsCouponModel } from '../../models/inModels/adsCoupon';

@Injectable()
export class AdsCouponsService {
	private route = '/api/coupons/ads';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<AdsCoupon> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as AdsCoupon)
			.catch(error => this.logging.handleError(error));
	}

	create(coupon: CreateAdsCouponModel): Promise<AdsCoupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as AdsCoupon)
			.catch(error => this.logging.handleError(error));
	}

	update(coupon: EditAdsCouponModel): Promise<AdsCoupon> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as AdsCoupon)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: string): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/business/ads-coupons.service.ts